import { primaryColors } from '@gocanvas/foundry/tokens/colors'
const { blue } = primaryColors
import { useSelector } from 'react-redux'
import { operationsSelector } from 'apps/builder/store/selectors'
import { lib } from '@gocanvas/client'
const {
  ADVANCED_LOOP_SHEET_TYPE_ID,
  LOOP_SHEET_TYPE_ID,
  LABELS_LEFT_SHEET_TYPE_ID,
  TABLE_LOOP_SHEET_STYLES,
  DEFAULT_SHEET_TYPE_ID,
  NORMAL_SECTION_TYPE_ID,
  GC_BLANK_DEFAULT,
  isTable,
  isAdvancedLoop,
  isLoop,
  isList,
} = lib

// TODO: We probably want to update all the references to pull directly from
// the client library, rather than importing from the utils file, but this
// is safer for now.
export {
  isTable,
  isAdvancedLoop,
  isLoop,
  isList,
}

// does not treat 0 as falsy
// isBlank :: Any -> Boolean
export const isBlank = value =>
  String(value).trim() === '' || value === null || value === undefined

// does not treat 0 as falsy
// isEmpty :: Any -> Boolean
export const isEmpty = value =>
  String(value).trim() === '' ||
  value === null ||
  value === undefined ||
  (Array.isArray(value) && !value.length) ||
  (typeof value === 'object' && !Object.keys(value).length)

// ensures we're not counting "undefined" === "undefined" as a match
// isTrueStringMatch (Any, Any) -> Boolean
export const isTrueStringMatch = (str1, str2) =>
  (
    str1 != null &&
    str1 !== '' &&
    str2 != null &&
    str2 !== ''
  ) &&
  `${str1}` === `${str2}`

export const typesList = [
  {
    type: 'Text',
    indicators: ['name', 'phone', 'first name', 'last name', 'text', 'short'],
  },
  {
    type: 'Date',
    indicators: ['date', 'week'],
  },
  {
    type: 'Signature',
    indicators: ['signature', 'sign'],
  },
  {
    type: 'Number',
    indicators: [
      'length',
      'count',
      'number',
      'total',
      'quantity',
      '#',
      'rate',
      'amount',
    ],
  },
  {
    type: 'Time',
    indicators: ['time', 'hour', 'minute'],
  },
  {
    type: 'Photo',
    indicators: ['photo', 'picture', 'image', 'images'],
  },
  {
    type: 'Single Choice',
    indicators: [
      'option',
      'choice',
      'weather',
      'parts',
      'materials',
      'type',
      'choose',
    ],
  },
  {
    type: 'Dropdown',
    indicators: [
      'option',
      'choice',
      'weather',
      'parts',
      'materials',
      'type',
      'choose',
    ],
  },
]

export const fieldOptions = [
  {
    label: 'First Name',
    value: 'Text',
  },
  {
    label: 'Last Name',
    value: 'Text',
  },
  {
    label: 'City',
    value: 'Text',
  },
  {
    label: 'Former Name',
    value: 'Text',
  },
  {
    label: 'Address',
    value: 'Text',
  },
  {
    label: 'Fax Number',
    value: 'Number',
  },
  {
    label: 'Phone Number',
    value: 'Text',
  },
  {
    label: 'State',
    value: 'Dropdown',
  },
  {
    label: 'Quantity',
    value: 'Number',
  },
  {
    label: 'Cost',
    value: 'Number',
  },
  {
    label: 'Date of Work',
    value: 'Date',
  },
]

const basicMatch = (words = [], indicators = []) => {
  const matches = words.filter(word =>
    indicators.find(indicator => word.includes(indicator))
  )
  return matches
}

export const classifyFieldByLabel = label => {
  const words = label.toLowerCase().replace(/\"/g, '').split(' ')
  const { type } =
    typesList.find(fieldType => {
      const { indicators } = fieldType
      const matches = basicMatch(words, indicators)
      return matches.length
    }) || typesList[0]

  return type
}

const legacyGuid = () => {
  var counter = 0
  function calculate(src) {
    return hex_sha1(src)
  }

  function hex_sha1(src) {
    return binb2hex(core_sha1(str2binb(src), src.length * 8))
  }

  function sha1_ft(t, b, c, d) {
    if (t < 20) return (b & c) | (~b & d)
    if (t < 40) return b ^ c ^ d
    if (t < 60) return (b & c) | (b & d) | (c & d)
    return b ^ c ^ d
  }

  function sha1_kt(t) {
    return t < 20
      ? 1518500249
      : t < 40
        ? 1859775393
        : t < 60
          ? -1894007588
          : -899497514
  }

  function safe_add(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff)
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
    return (msw << 16) | (lsw & 0xffff)
  }

  function rol(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt))
  }

  function str2binb(str) {
    var bin = new Array()
    var mask = (1 << 8) - 1
    for (var i = 0; i < str.length * 8; i += 8) {
      bin[i >> 5] |= (str.charCodeAt(i / 8) & mask) << (24 - (i % 32))
    }
    return bin
  }

  function binb2hex(binarray) {
    var str = new String('')
    var tab = new String('0123456789abcdef')
    for (var i = 0; i < binarray.length * 4; i++) {
      str +=
        tab.charAt((binarray[i >> 2] >> ((3 - (i % 4)) * 8 + 4)) & 0xf) +
        tab.charAt((binarray[i >> 2] >> ((3 - (i % 4)) * 8)) & 0xf)
    }
    return str
  }
  function core_sha1(x, len) {
    x[len >> 5] |= 0x80 << (24 - (len % 32))
    x[(((len + 64) >> 9) << 4) + 15] = len
    var w = new Array(80),
      a = 1732584193
    var b = -271733879,
      c = -1732584194
    var d = 271733878,
      e = -1009589776
    for (var i = 0; i < x.length; i += 16) {
      var olda = a,
        oldb = b
      var oldc = c,
        oldd = d,
        olde = e
      for (var j = 0; j < 80; j++) {
        if (j < 16) w[j] = x[i + j]
        else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)
        var t = safe_add(
          safe_add(rol(a, 5), sha1_ft(j, b, c, d)),
          safe_add(safe_add(e, w[j]), sha1_kt(j))
        )
        e = d
        d = c
        c = rol(b, 30)
        b = a
        a = t
      }
      a = safe_add(a, olda)
      b = safe_add(b, oldb)
      c = safe_add(c, oldc)
      d = safe_add(d, oldd)
      e = safe_add(e, olde)
    }
    return new Array(a, b, c, d, e)
  }

  var dt = new Date()
  var id1 = dt.getTime()
  var id2 = Math.random() * Number.MAX_VALUE

  var id3 = 'www.gocanvas.com'
  return calculate(id1 + id3 + id2 + counter++).toUpperCase()
}

export const guid = legacyGuid
// alternative use, but should be much faster than guid when available
export const createGuid = () =>
  window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : guid()

export const guidNumber = () => `temp-${Math.floor(Math.random() * 1e12)}`
export const matchByGuid = guid => entry => isTrueStringMatch(entry.guid, guid)
export const matchById = id => entry => isTrueStringMatch(entry.id, id)

// turn a string into a valid slug, usable in html5 ids
// slugify :: String -> String
export const slugify = string =>
  String(string)
    .trim()
    .replace(/\s/g, '-') // turn spaces into slugs
    .replace(/-+/g, '-') // only one dash allowed
    .toLowerCase()

export const validateMinRange = (minimum = '', num = '') => {
  if (minimum && Number(num) < Number(minimum)) {
    return false
  } else {
    return true
  }
}

export const validateMaxRange = (maximum = '', num = '') => {
  if (maximum && Number(num) > Number(maximum)) {
    return false
  } else {
    return true
  }
}

const toolTipImagesBasePath = '/images/gif/'
const fieldInfoForPalette = {
  Number: {
    toolTipMessage:
      'Only allow numbers to be entered into the field, like cost, phone number, quantity, etc. You can also use number fields in calculation, summary, and payment fields.',
    media: toolTipImagesBasePath + 'Number.png',
  },
  Decimal: {
    toolTipMessage:
      'A Decimal field allows the user to enter a number in response to a prompt.',
    media: null,
  },
  Date: {
    toolTipMessage:
      'Record a date, defaulted to the day the user opens the screen.',
    media: toolTipImagesBasePath + 'Date.png',
  },
  Time: {
    toolTipMessage:
      'Record a time, defaulted to the time the user opens the screen.',
    media: toolTipImagesBasePath + 'Time.png',
  },
  'Multiple Choice': {
    toolTipMessage:
      'Select multiple options from a list of choices. This type is limited to 15 options. ',
    media: toolTipImagesBasePath + 'Multichoice.png',
    fieldBubbleText: 'Add choices',
    isCompletedField: ({ entry_values = [], reference_data_id = '', data_source_context_id = '' }) =>
      entry_values.length || reference_data_id || data_source_context_id,
  },
  'Dropdown': {
    toolTipMessage:
      'Select one option from a list of choices, like state, parts, or customer names. Recommended for a list of 6 or more choices. ',
    media: toolTipImagesBasePath + 'Dropdown.png',
    fieldBubbleText: 'Add choices',
    isCompletedField: ({ entry_values = [], reference_data_id = '', data_source_context_id = '' }) =>
      entry_values.length || reference_data_id || data_source_context_id,
  },
  'Single Choice': {
    toolTipMessage:
      'Select one option from a list of choices, like state, parts, or customer names. Recommended for a list of 6 or more choices. ',
    media: toolTipImagesBasePath + 'Singlechoiceboxes.png',
    fieldBubbleText: 'Add choices',
    isCompletedField: ({ entry_values = [], reference_data_id = '', data_source_context_id = '' }) =>
      entry_values.length || reference_data_id || data_source_context_id,
  },
  'Pass/Fail': {
    toolTipMessage:
      'Users will be prompted to include additional information when they select "Fail."',
    media: toolTipImagesBasePath + 'PassFail.png',
  },
  Checkbox: {
    toolTipMessage:
      'An on/off toggle that appears as a checkbox. This works great for agreeing to terms and conditions, approving work, or confirming items in your form.',
    media: toolTipImagesBasePath + 'Checkbox.png',
  },
  'Long Text': {
    toolTipMessage:
      'Enter a long response, like a job description, status report, or incident summary.',
    media: toolTipImagesBasePath + 'LongText.png',
  },
  'Static Text': {
    toolTipMessage:
      'Display text to the user, like instructions or tips, that the user cannot change.',
    media: toolTipImagesBasePath + 'Static Text.png',
  },
  'Single Photo': {
    toolTipMessage:
      'You can add a single photo from your mobile devices gallery or camera to include in your form as part of this field.',
    media: toolTipImagesBasePath + 'Photo.png',
  },
  'Multiple Photos': {
    toolTipMessage:
      'You can add up to 10 photos from your mobile devices gallery or camera to include in your form as part of this field.',
    media: toolTipImagesBasePath + 'Photo.png',
  },
  Link: {
    toolTipMessage:
      'Link to a URL so users can view a web page while filling out their form. Great for linking to documents, diagrams, or instructions.',
    media: toolTipImagesBasePath + 'link.png',
  },
  Payment: {
    toolTipMessage:
      'Collect payment via Square based on a number, summary, or calculation field value. ',
    media: toolTipImagesBasePath + 'Payment.png',
    tooltipUrlText: 'Learn More',
    tooltipUrl: 'https://help.gocanvas.com/hc/en-us/articles/115006822368',
    fieldBubbleText: 'SETUP PAYMENT',
    isCompletedField: ({ dependent_entry = null }) => dependent_entry,
  },
  Calculation: {
    toolTipMessage:
      'Add, subtract, multiply, or divide based on a number field or constant. ',
    media: toolTipImagesBasePath + 'calculation.mp4',
    video: true,
    fieldBubbleText: 'Add Calculation',
    isCompletedField: ({ guid }) => {
      const operations = useSelector(operationsSelector)
      return operations.find(({ entry }) => entry === guid)
    },
  },
  Sum: {
    toolTipMessage:
      'Adds all of the instances of a field in a loop screen together. Think of this as totalling a column in a spreadsheet.',
    media: toolTipImagesBasePath + 'Summary.png',
  },
  GPS: {
    toolTipMessage:
      'Capture the current location of the device being used in longitude and latitude.',
    media: toolTipImagesBasePath + 'gps.mp4',
    video: true,
    altText: 'Location',
    capturedValue: 'Lat: 38.565434 | Lon: -77...',
  },
  Mirror: {
    toolTipMessage: 'Replicate a value entered in a previous field. ',
    media: toolTipImagesBasePath + 'Mirror.png',
    fieldBubbleText: 'Select a field to mirror',
    isCompletedField: ({ summary_entry = {} }) =>
      summary_entry?.guid,
  },
  'Static Image': {
    toolTipMessage:
      'Embed an image in your form, like a company logo, picture of an item or place, blueprint, or diagram.',
    media: toolTipImagesBasePath + 'Static Image.png',
    fieldBubbleText: 'Add Reference Image',
    isCompletedField: ({ summary_entry_id = null }) => summary_entry_id,
  },
  Drawing: {
    toolTipMessage:
      'You’ll be able to draw on a blank canvas or over a Reference Image directly from your mobile device.',
    media: toolTipImagesBasePath + 'Drawing.png',
  },
  Signature: {
    toolTipMessage:
      'Collect signatures directly on your mobile device. Perfect for confirming delivery, approving work orders or invoices, and accepting terms and conditions.',
    media: toolTipImagesBasePath + 'Signature.png',
  },
  Text: {
    toolTipMessage:
      'Enter just a few words, like a name, email address, or street address.',
    media: toolTipImagesBasePath + 'ShortText.png',
  },
  Barcode: {
    toolTipMessage: 'Scan a barcode with your phone.',
    media: toolTipImagesBasePath + 'barcode.mp4',
    video: true,
    capturedValue: '19390811001',
  },
  Video: {
    toolTipMessage: 'Record a video with your phone.',
    media: toolTipImagesBasePath + 'video.mp4',
    video: true
  },
  Increment: {
    toolTipMessage: 'Update the value of a number field using a + or - button.',
    media: toolTipImagesBasePath + 'Increment.png',
  },
  Rating: {
    toolTipMessage:
      'Rank the quality or status of something on a scale from 1 to 5 stars. Great for collecting feedback and reviews.',
    media: toolTipImagesBasePath + 'Ratings 2.png',
  },
  Slider: {
    toolTipMessage:
      'Allow users to make a selection from a range using a handle on a horizontal axis. Recommended for ratings above 5 and sliding scales. ',
    media: toolTipImagesBasePath + 'Slider.png',
  },
  'Single Choice Boxes': {
    toolTipMessage:
      'See all of the choices available (up to 5) in a row and choose one.',
    media: toolTipImagesBasePath + 'Singlechoiceboxes.png',
  },
  'Multiple Choice Buttons': {
    toolTipMessage:
      'Select as many options as you need from a list of up to 15 choices. ',
    media: toolTipImagesBasePath + 'multiplechoicebuttons.png',
  },
}

export const getTooltip = type => {
  return fieldInfoForPalette[type]
}

export const getFieldBubble = ({ type, original_type_id, ...entry }) => {
  //set default state if field obj doesn't contain these keys
  let fieldType

  // single photo
  if (original_type_id == '10') {
    fieldType = 'Single Photo'
    // multiple photos
  } else if (original_type_id == '25') {
    fieldType = 'Multiple Photos'
    // default
  } else {
    fieldType = type
  }

  const { fieldBubbleText = '', isCompletedField = () => true } =
    fieldInfoForPalette[fieldType] || {}
  const completedField = isCompletedField(entry)
  return { fieldBubbleText, completedField }
}

const colors = [Object.values(blue)[0], ...Object.values(blue).reverse()]
export const getPrimaryColor = index => colors[index]

export const fieldGroups = {
  'Text & Numbers': [
    'Text',
    'Static Text',
    'Number',
    'Calculation',
    'Increment',
    'Slider',
    'Rating',
    'Summary',
  ],
  Choices: ['Dropdown', 'Single Choice', 'Multiple Choice', 'Pass/Fail'],
  Multimedia: ['Photo', 'Static Image', 'Signature', 'Drawing', 'Video', 'Attachment'],
  'Date, Time, & Location': ['Date', 'Time', 'GPS'],
  Other: ['Checkbox', 'Barcode', 'Link', 'Payment', 'Mirror']
}

export const applyDefaultsOnSave = ({ entries }) => {
  return entries.map(entry => {
    const { type, style, entry_values } = entry
    if (type == 'Single Choice' && style == 5) {
      const vals = entry_values.map(
        ({ text, placeholder, position }, index) => {
          if (!text) {
            return {
              text: `Choice ${index + 1}`,
              placeholder,
              position,
            }
          }
          return {
            text,
            placeholder,
            position: index,
          }
        }
      )
      return {
        ...entry,
        entry_values: vals,
      }
    }
    return entry
  })
}

export const getFieldGroupByType = type => {
  const groups = Object.entries(fieldGroups)
  const [groupName] = groups.find(section => {
    const [group, entries] = section
    return entries.includes(type)
  }) || ['Other', fieldGroups.Other]

  return groupName
}

export const whiteListedTypesForCalculation = [
  'Number',
  'Rating',
  'Decimal',
  'Sum',
  'Date',
  'Time',
  'Calculation',
]

//TODO: Double check types
export const blackListedTypesForMirror = [
  'Photo',
  'Static Image',
  'Signature',
  'Drawing',
  'GPS',
  'Link',
  'Payment',
  'Mirror',
  'Video',
  'Attachment',
]

export const blackListedTypesForFollowUpName = [
  'Attachment',
  'Checkbox',
  'Drawing',
  'GPS',
  'Link',
  'Mirror',
  'Pass/Fail',
  'Payment',
  'Photo',
  'Rating',
  'Signature',
  'Static Image',
  'Video'
]

export const paymentDataToIncludeBlacklist = [
  'Photo',
  'Static Image',
  'Signature',
  'Drawing',
  'Payment',
  'Checkbox',
]

export const conditionEntryTypeWhiteList = [
  0, 1, 2, 3, 4, 5, 7, 8, 9, 12, 20, 21, 23,
]

export const referenceDataEligibleTypes = [
  'Text',
  'Long Text',
  'Static Text',
  'Number',
  'Barcode',
  'Link',
  'Rating',
]

// builder 2 allows all 4 types
const referenceDataEligibleDropdownStyles = ['0','4', '3', '34']

export const eligibleForReferenceData = entry => {
  const { type, style } = entry

  if (
    type === 'Dropdown' &&
    referenceDataEligibleDropdownStyles.includes(`${style}`)
  ) {
    return true
  }
  return referenceDataEligibleTypes.includes(type)
}

export const moreSettingsWhiteList = [
  'GPS',
  'Photo',
  'Checkbox',
  'Barcode',
  'Payment',
  'Mirror',
  'Calculation',
  'Sum',
]

export const whiteListedTypesForPaymentField = ['Sum', 'Calculation', 'Number']

export const invisibleFieldTypes = ['Sum', 'Multi Photo', 'Long Text']

export const getOperationType = operation_type_id => {
  const operationTypes = {
    1: 'add',
    2: 'multiply',
    3: 'subtract',
    4: 'divide',
  }

  const operationType = operationTypes[operation_type_id] || 'unknown'

  return operationType
}

export const conditionNames = {
  0: 'equals',
  1: 'does not equal',
  2: 'is less than',
  3: 'is less than or equal to',
  4: 'is greater than',
  5: 'is greater than or equal to',
  6: 'contains',
  7: 'starts with',
  8: 'ends with',
  9: 'does not contain',
  10: 'does not start with',
  11: 'does not end with',
}

export const getConditionName = ({ original_type_id } = {}) => {
  return conditionNames[original_type_id] || 'unknown'
}

/**
 *
 * @param {event} e
 */
export const disableBackspace = e => {
  const key = e.keyCode || e.charCode
  if (key == 8 || key == 46) {
    e.preventDefault()
    e.stopPropagation()
  }
}

export const sanitizeInput = (text = '') => {
  const tagsToRemove = ['script', 'submit', 'style', 'textarea', 'noscript']
  const removeTag = function (text, tag) {
    const openingTagToRemove = new RegExp(`<${tag}>`, 'g')
    const closingTagToRemove = new RegExp(`<\/${tag}>`, 'g')
    return text.replace(openingTagToRemove, '').replace(closingTagToRemove, '')
  }
  return tagsToRemove.reduce(removeTag, text)
}

export const preventDot = e => {
  var key = e.charCode ? e.charCode : e.keyCode
  if (key == 46) {
    e.preventDefault()
  }
}

export const roundDecimals = (e, mask) => {
  var value = Number(e.target.value).toFixed(mask)
  return value
}

export const checkNumberStyleForPaymentTotalField = ({ type, style }) => {
  if (type === 'Number') {
    if (style === 0 || style === 4) {
      return true
    } else {
      return false
    }
  }
  return true
}

// TODO: client library is cannonical place for this function, switch usages to that and delete this
export const getValue = (type, value, mirror = false) => {
  if ((type === 'Time' || type === 'Date') && value === 'BLANK') {
    return ''
  }

  if (value === GC_BLANK_DEFAULT) {
    return ''
  }

  if (type === 'Date' && mirror) {
    const date = value ? new Date(value) : new Date()
    return date.toLocaleDateString()
  }

  return value
}

export const TABLE_SHEET = 'table'
export const LIST_SHEET = 'list'
export const ADVANCED_LOOP_SHEET = 'advanced-loop'
export const LOOP_SHEET = 'loop'
export const NORMAL_SHEET = 'screen'

export const sheetType = sheet => {
  if (isList(sheet)) {
    return LIST_SHEET
  }

  if (isTable(sheet)) {
    return TABLE_SHEET
  }

  if (isAdvancedLoop(sheet)) {
    return ADVANCED_LOOP_SHEET
  }

  if (isLoop(sheet)) {
    return LOOP_SHEET
  }

  return NORMAL_SHEET
}

export const calculationFormatOptions = (builderType) => {
  const options = [
    { label: 'Number', value: 0 },
    { label: 'HH:MM', value: 1 },
    { label: 'HH:MM:SS', value: 2 },
    { label: 'MM:SS', value: 3 },
    { label: 'Currency', value: 4 },
  ]

  if (builderType === 'web-form') {
    return options.filter(option => [0, 4].includes(option.value))
  }
  return options
}

export const legacyUpdateScreenIndex = formData => {
  var appDefinition = { ...formData }
  if (appDefinition['sections']) {
    for (var i = 0; i < appDefinition.sections.length; i++) {
      // All sections get indexed
      appDefinition.sections[i].index = i
      for (var j = 0; j < appDefinition.sections[i].sheets.length; j++) {
        // Set the POSITION of the sections sheet to the INDEX of the sheet
        appDefinition.sections[i].sheets[j].position = j
        if (appDefinition.sections[i].sheets[j]['multi_section']) {
          // IF the sheet has a multi_section, set the
          // INDEX of the multi_section to the INDEX of the section
          for (var k = 0; k < appDefinition.sections.length; k++) {
            if (
              appDefinition.sections[k].description ==
              appDefinition.sections[i].sheets[j]['multi_section'][
                'description'
              ]
            ) {
              const multiSection =
                appDefinition.sections[i].sheets[j].multi_section
              const updatedMultiSection = {
                ...multiSection,
                index: k,
              }

              appDefinition.sections[i].sheets[j].multi_section =
                updatedMultiSection
              break
            }
          }
        }
      }
    }
  }
  return updateScreenPositions(appDefinition)
}

const isSimpleListSection = function (section) {
  return section.sheets.length == 1 && section.sheets[0].sheet_type_id == LABELS_LEFT_SHEET_TYPE_ID
}

const isNormalSection = function (section) {
  return section.section_type == NORMAL_SECTION_TYPE_ID
}

const updateScreenPositions = function (appDefinition) {
  if (appDefinition['sections']) {
    var position = 0
    var normal_sections = appDefinition.sections.filter(isNormalSection)

    for (var i = 0; i < normal_sections.length; i++) {
      normal_sections[i].position = position
      if (isSimpleListSection(normal_sections[i])) {
        if (normal_sections[i].sheets[0]['multi_section']) {
          position++
          normal_sections[i].sheets[0].multi_section.position = position
          appDefinition.sections[
            normal_sections[i].sheets[0].multi_section.index
          ].position = position
        }
      }
      position++
    }
    //update position of section for child sheets
    for (var i = 0; i < normal_sections.length; i++) {
      if (!isSimpleListSection(normal_sections[i])) {
        for (var j = 0; j < normal_sections[i].sheets.length; j++) {
          updateRecursiveSectionPosition(
            appDefinition,
            normal_sections[i].sheets[j],
            position
          )
        }
      }
    }
  }

  return appDefinition
}

const updateRecursiveSectionPosition = function (
  appDefinition,
  sheet,
  position
) {
  if (sheet['multi_section']) {
    var multiSection = appDefinition.sections[sheet.multi_section.index]
    sheet.multi_section.position = position
    multiSection.position = position
    position++
    if (isSimpleListSection(multiSection)) {
      if (multiSection.sheets[0]['multi_section']) {
        position++
        multiSection.sheets[0].multi_section.position = position
        appDefinition.sections[
          multiSection.sheets[0].multi_section.index
        ].position = position
      }
    }
    for (var j = 0; j < multiSection.sheets.length; j++) {
      updateRecursiveSectionPosition(
        appDefinition,
        multiSection.sheets[j],
        position
      )
    }
  }
}

// getAllDescendants :: ([String], [Sheet], Set) -> ()
// Given a list of multiSectionIds, adds all descendent sheet ids to a set
export const getAllDescendants = (multiSectionIds = [], sheets = [], set) => {
  const stack = multiSectionIds
  const sheetsBySectionMap = new Map()//section -> [sheetIds]
  const sheetsWithMultiSections = new Map()

  sheets.forEach(({ id, section_id, multi_section }) => {
    if (!sheetsBySectionMap.has(section_id)) {
      sheetsBySectionMap.set(section_id, [])
    }
    sheetsBySectionMap.get(section_id).push(id)
    if (multi_section) {
      sheetsWithMultiSections.set(id, multi_section)
    }
  })

  while (stack.length > 0) {
    const currentSectionId = stack.pop()
    const childSheets = sheetsBySectionMap.get(currentSectionId) || []
    childSheets.forEach(sheetId => {
      set.add(sheetId)
      if (sheetsWithMultiSections.has(sheetId)) {
        stack.push(sheetsWithMultiSections.get(sheetId))
      }
    })
  }
}

// skipIds is optionally the id of the item being edited, or an array of ids to overlook
// ensureUniqueProp :: String -> ([Object], String, Id||Array[String]) -> String
export const ensureUniqueProp = prop => (collection = [], proposedPropValue = '', skipIds) => {
  if (!Array.isArray(collection) || collection.length === 0) {
    return String(proposedPropValue).trim()
  }

  // normalize skipIds
  skipIds = skipIds
    ? (
      Array.isArray(skipIds)
        ? skipIds
        : [skipIds]
      ).map(String)
    : []

  // extract away the variant component, if any (#)
  const [proposedBaseName, variantNumber] = String(proposedPropValue).trim().match(/^(.*?)(?:\s\((\d+)\))?$/).slice(1,3)

  // if there is a variant # in the name, convert it to a number for the next comparison
  const number = variantNumber ? parseInt(variantNumber, 10) : 0

  // find the highest variant # of the props in the collection that match proposedBaseName
  const nextHighestVariantNumber = collection.reduce((acc, item) => {
    const propValue = String(item[prop] || '').trim()
    const [propBaseName, propVariantNumber] = propValue.match(/^(.*?)(?:\s\((\d+)\))?$/).slice(1,3)
    if (propBaseName === proposedBaseName && (!skipIds.includes(String(item.id)))) {
      const propNumber = propVariantNumber ? parseInt(propVariantNumber, 10) + 1 : 1
      return Math.max(propNumber, acc)
    }
    return acc
  }, number)

  return nextHighestVariantNumber > 0
    ? `${proposedBaseName} (${nextHighestVariantNumber})`
    : proposedBaseName
}

export const ensureUniqueDescription = ensureUniqueProp('description')
